import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import { KeyboardDateTimePicker } from "@material-ui/pickers";

function DateTimePickerField({ fieldName, helperText, ...rest }) {
    const onChangeHandler = (fieldName, value, form) => {
        const { setFieldValue } = form;
        const newValue = value ? value._d : null;
        setFieldValue(fieldName, newValue);

        const { onChange } = rest;

        if (onChange && typeof onChange === "function") {
            onChange(fieldName, newValue, form);
        }
    };

    return (
        <Field type="date" name={fieldName}>
            {({ field, form: { touched, errors, ...restForm } }) => (
                <KeyboardDateTimePicker
                    {...field}
                    {...rest}
                    format="MM/DD/YYYY H:mm"
                    onChange={(momentDate) => onChangeHandler(field.name, momentDate, restForm)}
                    ampm={false}
                    helperText={touched[field.name] ? errors[field.name] : helperText}
                    error={Boolean(touched[field.name]) && Boolean(errors[field.name])}
                    autoOk
                />
            )}
        </Field>
    );
}

DateTimePickerField.propTypes = {
    margin: PropTypes.string,
    fieldName: PropTypes.string.isRequired,
    helperText: PropTypes.string,
    fullWidth: PropTypes.bool,
    inputVariant: PropTypes.string,
    size: PropTypes.string,
    onChange: PropTypes.func,
};

DateTimePickerField.defaultProps = {
    margin: "normal",
    helperText: undefined,
    fullWidth: true,
    inputVariant: "outlined",
    size: "small",
    onChange: undefined,
};

export default DateTimePickerField;
